var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVc = function SvgVc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vc_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.582 15.571c.878 0 1.54-.364 2.027-.997l-.652-.494a1.72 1.72 0 0 1-1.375.676c-.952 0-1.643-.772-1.643-1.72 0-.947.68-1.763 1.67-1.763.441 0 .753.104 1.024.271v.833h.82v-1.214l-.157-.123c-.45-.353-1.139-.54-1.714-.54a2.546 2.546 0 0 0-2.55 2.536 2.546 2.546 0 0 0 2.55 2.535m1.7 5.003-.028-1.168v-2.85h-1.71v.816h.846v1.934c0 .832-.639 1.422-1.284 1.422s-.982-.445-.982-1.277v-2.894h-1.596v.815h.733v2.22c0 1.13.637 1.908 1.772 1.908.653 0 1.15-.36 1.447-.916h.013l.117.777h1.313v-.786h-.64v-.002m-4.439-9.954H15.42l-1.24 3.578h-.018l-1.233-3.578H11.41v.816h.854l1.47 4.079h.78v-.001l1.532-4.078h.797zm-6.766 10.752h.844v-.84h-.843zm3.26-3.87h-.01l-.052-.945h-1.507v.743h.802v3.274h-.802v.787h3.724v-.771h-2.073v-1.976c.093-.715.632-1.326 1.368-1.326h.013l-.015.731h.82v-1.476h-.648c-.742-.002-1.293.398-1.62.96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h32v32H10z"
  })))));
};
export default SvgVc;